import { render, staticRenderFns } from "./pictures.vue?vue&type=template&id=42b8a616&scoped=true"
import script from "./pictures.vue?vue&type=script&lang=js"
export * from "./pictures.vue?vue&type=script&lang=js"
import style0 from "./pictures.vue?vue&type=style&index=0&id=42b8a616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8a616",
  null
  
)

export default component.exports